const selectors = {
  popdownTrigger: 'data-popdown-toggle',
  close: '[data-close-popdown]',
  input: '[data-focus-input]',
};

const classes = {
  isVisible: 'is-visible',
};

let sections = {};

class SearchPopdownTriggers {
  constructor(trigger) {
    this.trigger = trigger;
    this.key = this.trigger.getAttribute(selectors.popdownTrigger);

    const popdownSelector = `[id='${this.key}']`;
    this.popdown = document.querySelector(popdownSelector);
    this.input = this.popdown.querySelector(selectors.input);
    this.close = this.popdown.querySelector(selectors.close);

    this.initTriggerEvents();
    this.initPopdownEvents();
  }
  initTriggerEvents() {
    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.key);
    this.trigger.addEventListener('click', function(evt) {
      evt.preventDefault();
      this.showPopdown();
    }.bind(this));
    this.trigger.addEventListener('keyup', function(evt) {
      if (evt.which !== window.theme.keyboardKeys.SPACE) { return; }
      this.showPopdown();
    }.bind(this));
  }
  initPopdownEvents() {
    this.popdown.addEventListener('keyup', function(evt) {
      if (evt.which !== window.theme.keyboardKeys.ESCAPE) { return; }
      this.hidePopdown();
    }.bind(this));
    this.close.addEventListener('click', function() {
      this.hidePopdown();
    }.bind(this));
  }
  hidePopdown() {
    this.popdown.classList.remove(classes.isVisible);
    this.trigger.focus();
  }
  showPopdown() {
    this.popdown.classList.add(classes.isVisible);
    this.input.focus();
  }
}

const searchPopdown = {
  onLoad() {
    sections[this.id] = {};
    const trigger = this.container.querySelector(`[${selectors.popdownTrigger}]`);
    if (trigger) {
      sections[this.id] = new SearchPopdownTriggers(trigger);
    }
  },
  onUnload: function() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
};

export default searchPopdown;
